<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">

  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item"><a routerLink="/home">Admin</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Tipo struttura</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Amministrazione – Tipo struttura</h4>
      <p class="text-muted small mb-0">Elenco tipi struttura (tabella tipo_struttura). Creazione, modifica ed eliminazione.</p>
    </div>
  </div>

  <mat-card class="p-2" appearance="outlined">
    <mat-card-content>
      @if (caricamento && tipiStruttura.length === 0) {
        <div class="text-center py-4">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="mt-2 mb-0">Caricamento...</p>
        </div>
      } @else if (errore && tipiStruttura.length === 0) {
        <p class="text-danger">{{ errore }}</p>
      } @else {
        <div class="d-flex justify-content-between align-items-center mb-3">
          <p class="mb-0"><b>{{ tipiStruttura.length }}</b> tipi struttura</p>
          <button mat-raised-button color="primary" (click)="aggiungi()">
            <mat-icon>add</mat-icon> Aggiungi tipo struttura
          </button>
        </div>
        @if (errore) {
          <p class="text-danger small mb-2">{{ errore }}</p>
        }
        <table mat-table [dataSource]="tipiStruttura" class="w-100">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let row">{{ row.id }}</td>
          </ng-container>
          <ng-container matColumnDef="codice">
            <th mat-header-cell *matHeaderCellDef>Codice</th>
            <td mat-cell *matCellDef="let row">{{ row.codice }}</td>
          </ng-container>
          <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let row">{{ row.descrizione }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Azioni</th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" (click)="modifica(row)">
                <mat-icon>edit</mat-icon> Modifica
              </button>
              <button mat-button color="warn" (click)="elimina(row)">
                <mat-icon>delete</mat-icon> Elimina
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              Nessun tipo struttura. Clicca "Aggiungi tipo struttura" per crearne uno.
            </td>
          </tr>
        </table>
      }
    </mat-card-content>
  </mat-card>

</div>

<app-footer></app-footer>
